import React from 'react';
import { useApp } from '../../context/appContext';
import { getAssetUrl } from '../../utils/lib';

const BreadcrumbStep = ({ name, isActive, index, link }) => {
  const { setCurrentPage, currentPage } = useApp();
  const iconSrc = isActive 
    ? require(`../../assets/icons/step${index}-icon.svg`) 
    : require(`../../assets/icons/step${index}-icon-disabled.svg`);

  const handlePage = (page) => {
    if(currentPage !== page) setCurrentPage(page)
  }

  return (
    <div className="breadcrumb-step">
      {isActive ? (
        <>
          <span onClick={() => handlePage(link)} className="step-link-image">
            <img src={getAssetUrl(iconSrc)} alt={`Step ${index} icon`} className="step-icon" />
          </span>
          <span onClick={() => handlePage(link)} className="step-link">
            {name}
          </span>
        </>
      ) : (
        <>
          <img src={getAssetUrl(iconSrc)} alt={`Step ${index} icon`} className="step-icon" />
          <span className="step-name">{name}</span>
        </>
      )}
    </div>
  );
};

export default BreadcrumbStep;

